export default __webpack_public_path__ + "static/media/chopy_m.f4c6abb2.jpg";